import { AcceptInvitationForm } from '@/components/auth/AcceptInvitationForm';

export function AcceptInvite() {
  return (
    <div className="container py-10">
      <AcceptInvitationForm />
    </div>
  );
} 